module.exports = "https://portperrypedals.ca/_res/img/lhf.abfa78c.svg";